import { styled } from "styled-components";

export const ScreenHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    padding-bottom: ${({ theme }) => theme.spacing[3]};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
`;

export const Header = styled.div``;

export const HeaderInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => theme.spacing[4]};
`;

export const HeaderTitle = styled.div`
  font-size: ${({ theme }) => theme.fonts["3xl"].fontSize};
  font-weight: 700;
`;

export const HeaderDescription = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
`;

export const Content = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
`;

export const TabContent = styled.div`
  padding-top: ${({ theme }) => theme.spacing[4]};
`;
